<template lang="html">
    <div>
        <Heading :title="$t('about') + ' ' + capitalize($t('site_tpf'))" :routeName="'vignette'"></Heading>
        <AboutPeajContent/>
    </div>

</template>

<script>

import Heading from './snippets/Heading.vue'
import AboutPeajContent from './AboutPeajContent.vue'

export default {
    name: 'AboutPeaj',
    components: {
        Heading,
        AboutPeajContent
    },
    props: {
    }
}

</script>

<style lang="scss" scoped>
</style>
